import { render, staticRenderFns } from "./IconWrapper.vue?vue&type=template&id=3377286e&scoped=true"
import script from "./IconWrapper.vue?vue&type=script&lang=js"
export * from "./IconWrapper.vue?vue&type=script&lang=js"
import style0 from "./IconWrapper.vue?vue&type=style&index=0&id=3377286e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377286e",
  null
  
)

export default component.exports